module.exports = __webpack_public_path__ + "img/subscription-type-header.f7572835.svg";